<template lang="">
  <b-link
    size="sm"
    variant="flat-primary"
    v-bind="[$attrs]"
    @click.stop="e => onClick(e)"
  >
    <slot />
  </b-link>
</template>
<script>
import { ref } from '@vue/composition-api'
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
  props: {
    delayTime: {
      type: Number,
      default: 200,
    },
    disableDoubleClick: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const clickCount = ref(0)
    const timer = ref()
    function onClick(e) {
      e.preventDefault()
      if (props.disableDoubleClick) {
        emit('single-click', e)
        return
      }
      clickCount.value += 1

      if (clickCount.value === 1) {
        timer.value = setTimeout(() => {
          clickCount.value = 0
          emit('single-click', e)
        }, props.delayTime)
      } else if (clickCount.value === 2) {
        clickCount.value = 0
        clearTimeout(timer.value)
        emit('dbl-click', e)
      }
    }
    return { onClick }
  },
}
</script>
<style lang="">

</style>
